import { Component, OnInit, Output, EventEmitter, Input, Injectable, SimpleChanges, ViewChild } from '@angular/core';
import {FormBuilder, Validators, FormGroup, FormControl, ValidatorFn, AbstractControl, ValidationErrors, NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { fields } from './form_fields'

@Injectable({
  providedIn: 'root'
})
class AgeService {
    getAgeByMedical(val:any) {
        return val;
    }
}


@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {

  @Input() audiometryInput:any;

  @Output() formChanges = new EventEmitter();

  isoTypeList = [{ id: 'guideline', title: 'Guidelines' }, { id: 'iso2000', title: 'ISO7029:2000' }, { id: 'iso2017', title: 'ISO7029:2017' }];

  @ViewChild('f') form: NgForm;

  arhlCalcIn: { [key: string]: any }[] = fields;
  showAnchor:boolean = false;
  calcForm: FormGroup;
  calcFormFields: { [key: string]: any } = {
    basic: new FormGroup({
      standard : new FormControl('guideline')
    })
  };

  defaultValues: any = {
    "arhlParam": 1
  };
  
  constructor(
    private fb:FormBuilder,
    private ageService:AgeService
  ) { 
    this.calcForm = this.fb.group(this.calcFormFields);
  }

  ngOnInit(): void {
   
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.audiometryInput = changes['audiometryInput'].currentValue;
    this.calcFormInit();
  }
  
  isVisible(id:any):boolean {
    if(id == 'newUpperAnchor' || id == 'newLowerAnchor'){
      return this.showAnchor;
    }
    return true;
  }
  centileValidator():ValidatorFn {
    return (control:AbstractControl ): ValidationErrors | null  => {
      const value = control.value;
      if (!value) {
          return null;
      }
      return (value < 5 || value > 95) ? { invalid: true} : null;
    }
  }

  calcFormInit() {
    for (const { id, questions } of this.arhlCalcIn) {
      let calcFormGroup: any = {};
      for (const { title, id, required, relationalId, defaultValue } of questions) {
        let defVal:any = '';
        if (defaultValue) defVal = defaultValue;
        
        if(this.defaultValues[id]){
          defVal= this.defaultValues[id];
        }
      
        // if(id == 'changeAgeTo'){
        //   defVal = this.ageService.getAgeByMedical(this.audiometryInput);
        // }
        if (id== 'newDbValue') {
          defVal = this.audiometryInput.notionalExposure;
        }

        const formValidator = [];
        const reqValid = required ? formValidator.push(Validators.required) : '';
        if(id == 'changeCentileTo') {
          formValidator.push(this.centileValidator());
        }
        calcFormGroup[id] = [defVal, formValidator]
      }
       this.calcFormFields[id] = this.fb.group(calcFormGroup)
    }
    this.calcForm = this.fb.group(this.calcFormFields)
   
    this.calcForm.get(['anchor','changeAnchorPoints'])?.valueChanges.subscribe((val => {
        if(val){
          this.showAnchor =true;
        }else{
          this.showAnchor = false;
        }
    }))
    this.calcForm.valueChanges.subscribe(val => {
        val["anchor"]["changeAnchorPoints"] =  val["anchor"]["changeAnchorPoints"] ? 'yes' : 'no';
        if(this.calcForm.valid){
          this.formChanges.emit(val);
        }
    })
  }
  hasError(section:string, id:string):boolean {
    let errors = this.calcForm.get(section)?.get(id)?.errors;
    if(!errors) {
      return false;
    }
    return Object.keys(errors).length > 0 ?  true : false;
  }

}
